import React from "react";
import Data from "../../assets/data/data";
import { Link } from "react-router-dom";

const Catalog = () => {
  const catalogData = Data.find((item) => item.id === 2)?.catalog || [];

  return (
    <section className="py-14 px-5 sm:px-14 md:px-16 lg:px-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {catalogData.map((item, id) => (
          <div key={id}>
            {[
              "Foods",
              "Live Music",
              "Todays Special",
              "Party Packages",
            ].includes(item.title) ? (
              <Link
                to={`/catalog/${encodeURIComponent(
                  item.title.toLowerCase().replace(/\s+/g, "-")
                )}`}
              >
                <CatalogCard item={item} />
              </Link>
            ) : (
              <CatalogCard item={item} />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

const CatalogCard = ({ item }) => (
  <div>
    <img
      src={item.image}
      alt={item.title}
      className="w-full min-h-[20em] object-cover rounded-t-md"
    />
    <div className="bg-gray-500 text-white font-bold text-center rounded-b-lg p-2">
      {item.title}
    </div>
  </div>
);

export default Catalog;
